export default "__VITE_ASSET__reBuu6Js__"